import { usePlaylistCurrentlySelected } from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';
import { selectedVisEventsAtom } from '@/atoms/vis/selection';
import { useVideoDataForEvents } from './useVideoDataForEvents';

export const useCurrentlySelectedVideoId = () => {
  const [videoPlaylistCurrentlySelected] = usePlaylistCurrentlySelected();

  const selectedVisEvents = useAtomValue(selectedVisEventsAtom);
  const { videoIds, ref } = useVideoDataForEvents<HTMLDivElement>(selectedVisEvents || []);

  return {
    ref,
    currentlySelectedVideoId:
      videoIds?.length && videoPlaylistCurrentlySelected?.id ? videoPlaylistCurrentlySelected.id : null,
  };
};
